import React from 'react'

function Footer() {
    return (
        <footer>SimplyShop CopyRight @ --/--</footer>
    )
}

export default Footer